module.exports = __webpack_public_path__ + "img/microsoft-teams.71c7a9dc.svg";